import BaseViewModel, { BaseViewModelParams } from './BaseViewModel';

class FloatControlViewModel extends BaseViewModel {
	Mask: string;
	MaxValue: number = Number.MAX_VALUE;
	MinValue: number = Number.MIN_VALUE;

	constructor(params: BaseViewModelParams) {
		super(params);
		// Разбор параметров.
		this.Mask =
			'^(0|0[.,]00|0[.,][1-9]|0[.,][1-9]0|0[.,]0[1-9]|0[.,][1-9]{2}|[1-9]\\d*([.,]\\d{1,2})?)$';
		this.MaxValue = +params.elementDescriptor.MaxValue;
		this.MinValue = +params.elementDescriptor.MinValue;
	}

	runValidation = () => {
		const regExpr = new RegExp(this.Mask, 'ig');
		return regExpr.test(this.Value);
	};
}

export default FloatControlViewModel;
